import { getGlobal, setGlobal } from '../../../global/useGlobal'
import { GetStatement_listStatements_installmentsOverdue } from '../../../services/types/GetStatement'

interface Installments extends GetStatement_listStatements_installmentsOverdue {}

export const setQuantityBankSlip = (installment: Installments) => {
  setGlobal({ duplicatesBankSlip: [installment] })
}

export const addSecondBankSlip = (installment: Installments) => {
  const currentDuplicatesBankSlip = getGlobal()?.duplicatesBankSlip || []
  const duplicatesBankSlip = [...currentDuplicatesBankSlip, installment]
  setGlobal({ duplicatesBankSlip })
}

export const addManySecondBankSlip = (installments: Installments[]) => {
  const currentDuplicatesBankSlip = getGlobal()?.duplicatesBankSlip || []
  const duplicatesBankSlip = [...currentDuplicatesBankSlip, ...installments]
  setGlobal({ duplicatesBankSlip })
}
